import React, { Component } from "react";

import "./Presentation.styl";
import { Icon } from "@mui/material";
import Text from "./Text";
import Screen from "./Screen";

class PresentationContainer extends Component {
    displayName = PresentationContainer.name;

    state = { visibleSlideIndex: 0, previousSlideIndex: 0, pause: false, slideHeight: 0, slide: null };
    changeSlideTimer = null;
    adjustHeightTimer = null;

    static DEFAULT = {
        SLIDE_DURATION: 4000,
        SIBLING_DELAY: 200,
    };
    static _id = 1;
    id = PresentationContainer._id++;

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.slideRefs = [];
        this.childrenArray = React.Children.toArray(this.props.children);
        this.childrenArray.forEach(() => this.slideRefs.push(React.createRef()));
    }


    mergeState = (newState) => this.setState(oldState => ({ ...oldState, ...newState }));

    resetPresentation = () => this.mergeState({ visibleSlideIndex: 0 });

    componentDidMount() {
        const slide = this.slideRefs[0].current;
        this.mergeState({ slideHeight: slide.offsetHeight, slide });
        this.changeSlideTimer = setTimeout(this.goForward, this.childrenArray[0].props.duration || PresentationContainer.DEFAULT.SLIDE_DURATION);
        this.adjustHeightTimer = setTimeout(this.adjustHeight, 500);
        Screen.addResizeListener(this.adjustHeight);
    }


    componentWillUnmount() {
        if (this.changeSlideTimer) clearTimeout(this.changeSlideTimer);
        this.changeSlideTimer = null;
        if (this.adjustHeightTimer) clearTimeout(this.adjustHeightTimer);
        this.adjustHeightTimer = null;
        Screen.removeResizeListener(this.adjustHeight);
    }

    onSlideActive = (child) => {
        const node = this.slideRefs[child.props.index].current;
        if (node) {
            this.mergeState({ slide: node, slideHeight: node.offsetHeight });
            this.adjustHeight();
        }
    }


    goTo = (nextSlideIndex) => {
        if (this.changeSlideTimer) clearTimeout(this.changeSlideTimer);
        this.mergeState({ previousSlideIndex: this.state.visibleSlideIndex, visibleSlideIndex: nextSlideIndex });
        this.changeSlideTimer = setTimeout(this.goForward, this.childrenArray[nextSlideIndex].props.duration || PresentationContainer.DEFAULT.SLIDE_DURATION);
    }

    goForward = () => {
        let nextSlideIndex = this.props.pause ? this.state.visibleSlideIndex : (this.props.forwardOnly ? Math.min(this.state.visibleSlideIndex + 1, this.childrenArray.length - 1) : (this.state.visibleSlideIndex + 1) % this.childrenArray.length);
        if (this.props.pause || this.state.pause) {
            this.changeSlideTimer = setTimeout(this.goForward, this.childrenArray[nextSlideIndex].props.duration || PresentationContainer.DEFAULT.SLIDE_DURATION);
            return;
        }
        this.goTo(nextSlideIndex);
    }

    adjustHeight = () => {
        if (this.state.slide !== null && this.state.slideHeight !== this.state.slide.offsetHeight) {
            this.mergeState({ slideHeight: this.state.slide.offsetHeight });
        }
    }

    selectSlideHandlers = {};

    selectSlide = (index) => {
        if (!this.selectSlideHandlers[index]) {
            this.selectSlideHandlers[index] = () => {
                this.goTo(index);
            }
        }
        return this.selectSlideHandlers[index];
    }

    getSiblingDelay = () => this.state.visibleSlideIndex !== this.state.previousSlideIndex ? (this.childrenArray[this.state.previousSlideIndex].props.delay || PresentationContainer.DEFAULT.SIBLING_DELAY) : 0;

    pausePresentation = () => this.mergeState({ pause: true });
    resumePresentation = () => this.mergeState({ pause: false });
    isPaused = () => this.props.pause === true || this.state.pause === true;

    render() {
        return (
            <div ref={this.myRef} className="PresentationContainer" aria-label={this.props["aria-label"] || "apresentação de slides"} style={{ minHeight: this.state.slideHeight }} onMouseOver={this.pausePresentation} onMouseLeave={this.resumePresentation}>
                {
                    this.isPaused()
                    ? (
                        <div className="pause-background"><Icon className="pause-icon">pause</Icon><Text className="pause-text">Pausado</Text></div>
                    )
                    : null
                }
                {
                    React.Children.map(this.props.children, (child, index) =>
                        React.cloneElement(child, { ...child.props, index, ref: this.slideRefs[index], active: index === this.state.visibleSlideIndex, resetPresentation: this.resetPresentation, siblingDelay: this.getSiblingDelay(), onActive: this.onSlideActive }, child.props.children)
                    )
                }
                <div className="button-container">
                {
                    React.Children.map(this.props.children, (child, index) =>
                        <span onClick={this.selectSlide(index)}><Icon className="icon">{index === this.state.visibleSlideIndex ? "lens" : "panorama_fish_eye" }</Icon></span>
                    )
                }
                </div>
            </div>
        )
    }
}

class PresentationSlide extends Component {
    displayName = PresentationSlide.name;

    state = { active: false };
    timer = null;

    componentDidUpdate() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        if (this.props.active && !this.state.active) {
            this.timer = setTimeout(() => {
                this.setState({ active: true });
                this.props.onActive && this.props.onActive(this);
            }, this.props.siblingDelay);
        }
        else if (!this.props.active && this.state.active) {
            this.timer = setTimeout(() => {
                this.setState({ active: false });
            }, this.props.siblingDelay);
        };
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    renderChildren = () => {
        if (this.props.children && this.props.children.constructor === Function) {
            return this.props.children({ active: this.props.active && this.state.active, resetPresentation: this.props.resetPresentation });
        }
        return this.props.children;
    }

    static getClassName(active) {
        return `PresentationSlide${active ? " active" : ""}`;
    }

    render() {
        return (
            <div className={PresentationSlide.getClassName(this.state.active)} aria-label={this.props["aria-label"] || `slide ${this.props.index + 1}`}>
            {
                this.renderChildren()
            }
            </div>
        )
    }
}

PresentationContainer.Slide = PresentationSlide;

export default PresentationContainer;
